"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_device_detect_1 = require("react-device-detect");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const string_utils_1 = require("@/common/string_utils");
const material_ui_confirm_1 = require("material-ui-confirm");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ userId, formReturn, }) {
    const { watch, setValue } = formReturn;
    const proofFiles = Array.from(watch('proof_files') || []);
    const { t } = (0, react_i18next_1.useTranslation)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const ProofFile = ({ proofFile }) => {
        const { media_id, fileUrl, fileName } = proofFile;
        const isPDF = fileName.includes('pdf');
        const isHeicHeif = fileName.includes('heic') || fileName.includes('heif');
        // ? MobileSafari 제외한 다른 브라우저에서 heic/heif 이미지 표시 안됨, displayName으로 대체
        const isDisplayNameRequired = isPDF || (!react_device_detect_1.isMobileSafari && isHeicHeif);
        const displayName = isDisplayNameRequired ? (0, string_utils_1.truncateFileName)(6, fileName) : '';
        const [isDeleting, setIsDeleting] = (0, react_1.useState)(false);
        const deleteProofFile = () => __awaiter(this, void 0, void 0, function* () {
            setIsDeleting(true);
            yield (0, api_1.deleteData)(`/api/v1/members/${userId}/settlement-request/upload?media_id=${media_id}`)
                .then(() => {
                setValue('proof_files', proofFiles.filter(file => file.media_id !== media_id));
                (0, functions_1.showToastMessage)({ message: t('삭제 완료') });
            })
                .catch(err => {
                var _a, _b, _c, _d;
                const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
                const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                if (errorStatus === 403)
                    (0, errors_1.handle403Error)(err);
                else
                    (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
                setIsDeleting(false);
            });
        });
        const onProofFileDeleteClick = () => {
            confirm({
                description: t('삭제하시겠어요?'),
                confirmationText: t('영원히 삭제'),
            })
                .then(deleteProofFile)
                .catch(() => { });
        };
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                rowGap: '4px',
                width: '56px',
                '> div': { position: 'relative', width: '56px', height: '56px' },
            } }, { children: [isDisplayNameRequired ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "surface-table-row", css: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '8px',
                                border: '1px solid var(--gray-5)',
                            } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.PdfIconYellowSvg, {}) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "gray-80", css: {
                                display: 'flex',
                                lineHeight: '18px',
                                fontSize: '12px',
                                wordBreak: 'break-all',
                                textAlign: 'center',
                            } }, { children: displayName }))] })) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                        '&:after': (0, functions_1.afterImgWrapper)({
                            border: '1px solid var(--gray-5)',
                            borderRadius: '8px',
                        }),
                    } }, { children: (0, jsx_runtime_1.jsx)("img", { src: fileUrl, css: {
                            width: '100%',
                            height: '100%',
                            borderRadius: '8px',
                            objectFit: 'cover',
                        } }) }))), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ disabled: isDeleting, onClick: onProofFileDeleteClick, sx: { position: 'absolute', top: '-4px', right: '-4px', p: 0 } }, { children: isDeleting ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(0, 0, 0, 0.2)',
                        } }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 10, color: "info", thickness: 8 }) }))) : ((0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: { width: '16px', height: '16px' } })) }))] })));
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: proofFiles.map((proofFile, index) => {
            const { media_id } = proofFile;
            return (0, jsx_runtime_1.jsx)(ProofFile, { proofFile: proofFile }, `proof_file_${media_id}_${index}`);
        }) }));
}
exports.default = default_1;
